import Container from "@material-ui/core/Container"
import React from "react"
import { makeStyles } from "@material-ui/core"
import { Typography, Grid } from "@material-ui/core/index"
import { injectIntl } from "gatsby-plugin-intl"
import frederikMap from "../images/map/Frederikplein 47b, Amsterdam.webp"
import bergenMap from "../images/map/dokter-van-peltlaan-5-bergen.webp"
import frederikThumbnail from "../images/map/frederiksplein thumbnail.webp"
import bergenThumbnail from "../images/map/bergen-thumbnail.webp"

const useStyles = makeStyles((theme) => ({
  missionContainer: {
    backgroundColor: "#202020",
    padding: theme.spacing(10, 4),
    [theme.breakpoints.down("xs")]: {
      padding: theme.spacing(7, 2.5),
    },
  },
  missionHeader: {
    maxWidth: 1280,
    margin: "0 auto",
    marginBottom: theme.spacing(3),
  },
  missionHeaderText: {
    color: "#fff",
    fontWeight: 300,
    fontSize: "2.3rem",
    lineHeight: 1.15,
    ["@media (max-width:600px)"]: {
      fontSize: "1.9rem",
    },
  },
  mapGrid: {
    maxWidth: 1280,
    margin: "0 auto",
  },
  mapGridInner: {
    maxWidth: 1136,
  },
  mapImageContainer: {
    position: "relative",
    overflow: "hidden",
    borderRadius: "12px",
    cursor: "pointer",
    transition: "transform 0.3s ease, box-shadow 0.3s ease",
    "&:hover": {
      transform: "scale(1.03)",
      boxShadow: "0 10px 25px rgba(0,0,0,0.45)",
    },
  },
  mapImage: {
    width: "100%",
    // pin all maps to the same shape (the Amsterdam maps are 1400x1100 = 14/11) so every
    // card is equal height regardless of the source image's native aspect ratio
    aspectRatio: "14 / 11",
    objectFit: "cover",
    display: "block",
  },
  addressOverlay: {
    position: "absolute",
    top: "0",
    left: "0",
    right: "0",
    backgroundColor: "rgba(255, 255, 255, 0.9)",
    padding: "12px 18px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
    zIndex: 1,
    backdropFilter: "blur(8px)",
  },
  addressText: {
    color: "#333",
    fontSize: "13px",
    fontWeight: 600,
    margin: 0,
    letterSpacing: "0.3px",
    whiteSpace: "nowrap",
    ["@media (max-width:600px)"]: {
      fontSize: "11px",
      padding: "0",
    },
  },
  thumbnailOverlay: {
    position: "absolute",
    bottom: "0",
    right: "0",
    width: "130px",
    height: "95px",
    overflow: "hidden",
    boxShadow: "0 -4px 12px rgba(0,0,0,0.15)",
    zIndex: 1,
    ["@media (max-width:600px)"]: {
      width: "100px",
      height: "75px",
    },
  },
  thumbnailImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    display: "block",
  },
}))

const ClinicImageSection = ({ intl }) => {
  const classes = useStyles()

  const clinics = [
    {
      map: frederikMap,
      thumbnail: frederikThumbnail,
      url: "https://www.google.com/maps/search/?api=1&query=Frederiksplein+47B,+1017+XL+Amsterdam",
      alt: "Frederiksplein 47B, Amsterdam",
      address: "Frederiksplein 47B, Amsterdam",
    },
    {
      map: bergenMap,
      thumbnail: bergenThumbnail,
      url: "https://www.google.com/maps/search/?api=1&query=Dokter+van+Peltlaan+5,+1861+KA+Bergen",
      alt: "Dokter van Peltlaan 5, Bergen",
      address: "Dokter van Peltlaan 5, Bergen",
    },
  ]

  return (
    <Container
      maxWidth={false}
      component="section"
      className={classes.missionContainer}
    >
      <div className={classes.missionHeader}>
        <Typography component="h2" className={classes.missionHeaderText}>
          {intl.formatMessage({ id: "home.ClinicImagesTitle" })}
        </Typography>
      </div>
      <div className={classes.mapGrid}>
        <Grid container spacing={3} className={classes.mapGridInner}>
          {clinics.map((clinic, index) => (
            <Grid item xs={12} md={4} key={index}>
              <a
                href={clinic.url}
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none" }}
              >
                <div className={classes.mapImageContainer}>
                  <div className={classes.addressOverlay}>
                    <p className={classes.addressText}>{clinic.address}</p>
                  </div>
                  <div className={classes.thumbnailOverlay}>
                    <img
                      src={clinic.thumbnail}
                      alt={`${clinic.alt} thumbnail`}
                      loading="lazy"
                      decoding="async"
                      className={classes.thumbnailImage}
                    />
                  </div>
                  <img
                    src={clinic.map}
                    alt={clinic.alt}
                    loading="lazy"
                    decoding="async"
                    className={classes.mapImage}
                  />
                </div>
              </a>
            </Grid>
          ))}
        </Grid>
      </div>
    </Container>
  )
}

export default injectIntl(ClinicImageSection)
